// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  shellWrapper: {
    minWidth: 960,
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    // Cooperating overlay panels (the Khora drawer) shift the app content beside them by setting
    // this CSS variable on the document root. Unset, the margin is 0 and this rule is inert — the
    // Shell carries no panel logic and doesn't re-render when the offset changes.
    marginRight: 'var(--khora-drawer-offset, 0px)',
    transition: 'margin-right 225ms ease',
  },
  headerWrapper: {
    flex: '0 1 auto',
  },
  contentWrapper: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    minHeight: 0,
    overflow: 'auto',
  },
});

export default styles;
